import { PlatformType } from 'osn-shared';
import { PartialProgram } from '../../../domain/program';
import { PlatformLocalizedImagesViewModel } from '../../../shared/components/image-upload-control/image-upload-view-model';
import { LocalizedFormData } from '../../common/localized-form-data';
import { SchedulingControlViewModel } from '../scheduling-control/scheduling-control-view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';

export enum SeasonTraySortViewModel {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export interface SeasonTrayFormViewModel {
  id?: string;
  title: LocalizedFormData<string>;
  description: LocalizedFormData<string>;
  userSegmentIds: string[];
  platformIds: string[];
  countryIds: string[];
  type: TrayFormViewModelType.SeasonTray;
  seriesId: string;
  scheduling: SchedulingControlViewModel;
  backgroundImages: PlatformLocalizedImagesViewModel<PlatformType.BigScreen | PlatformType.Web | PlatformType.Tablet | PlatformType.Mobile>;
  sort: SeasonTraySortViewModel;
  program: PartialProgram;
}
